import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import ProductStreamLayout from 'sharedComponents/ProductStream/ProductStreamLayout'
import ErrorBoundary from 'sharedComponents/Utils/ErrorBoundary'
import { useSearchPageStore } from 'store/context'
import { ProductStreamContextProvider } from 'store/sidecar/ProductStreamContext'
import { SearchPageSideNavigation } from './SearchPageSideNavigation'
import SearchProductList from './SearchProductList/SearchProductList'
import { useSearchTerm } from './useSearchTerm'

const Search: React.FC<SearchTrackInterface> = ({ shouldTrackSearch }) => {
  const { t } = useTranslation()
  const searchPageStore = useSearchPageStore()
  const searchTerm = useSearchTerm()
  const isLoading = useSearchPageStore(store => store.streamLoading)
  const productsCount = searchPageStore.pagination.total

  const { filter, pagination, sorting, category } = useSearchPageStore()

  useEffect(() => {
    shouldTrackSearch()
  }, [])

  const title = t(
    'Deine Suche nach "{{- searchTerm}}" hat {{productsCount}} Ergebnisse ergeben | ABOUT YOU',
    { searchTerm, productsCount },
  )
  const description = t(
    'Bei ABOUT YOU findest Du über die Suchfunktion Deine gewünschten Produkte noch schneller. Deine Suche nach "{{- searchTerm}}" hat {{productsCount}} Ergebnisse ergeben. Bestelle jetzt versandkostenfrei bei ABOUT YOU.',
    { searchTerm, productsCount },
  )

  return (
    <ProductStreamContextProvider
      filterViewStore={filter}
      paginationViewStore={pagination}
      sortingViewStore={sorting}
      categoryViewStore={category}
      pageType={'search'}
    >
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content={description} />
      </Helmet>
      {!isLoading && <TrackContentPageView pageTitle={title} />}
      <ProductStreamLayout
        padded
        paddingTopOverwrite={'28px'}
        navigation={
          <ErrorBoundary>
            <SearchPageSideNavigation />
          </ErrorBoundary>
        }
        main={<SearchProductList />}
      />
    </ProductStreamContextProvider>
  )
}

interface SearchTrackInterface {
  shouldTrackSearch: VoidFunction
}

const TrackedSearchPage: React.FC<SearchTrackInterface> = ({
  shouldTrackSearch,
}) => {
  const { path, search } = useTrackingPageUrl()

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.Search}
    >
      <Search shouldTrackSearch={shouldTrackSearch} />
    </PageTrackingContextProvider>
  )
}

export default TrackedSearchPage
